import Vue from 'vue'
import Router from 'vue-router'
import Middle from '../components/Middle';
import Index from '../components/Index';
import Home from '../components/Home';
import Introduction from '../components/About/Introduction';
import New from '../components/About/NewsDetail.vue';
import NewsList from "@/components/About/NewsList";
import ProductSite from '../components/product/ProductSite';
import ProductSafety from '../components/product/ProductSafety';
import ProductCartoon from '../components/product/ProductCartoon';
import SiteDetail from '../components/product/SiteDetail';
import CartoonDetail from '../components/product/CartoonDetail';
import Safety1 from '../components/product/Safety1';
import Safety2 from '../components/product/Safety2';
import Safety3 from '../components/product/Safety3';
import Safety4 from '../components/product/Safety4';
import ProductSafetyDetail from '../components/product/ProductSafetyDetail';
import Live from '../components/scheme/Live';
import LiveDetail from '../components/scheme/LiveDetail';
import Site from '../components/scheme/Site';
import SchemeSafety from '../components/scheme/SchemeSafety';
import SchemeCartoon from '../components/scheme/SchemeCartoon';
import SchemeSiteDetail from '../components/scheme/SchemeSiteDetail';
import SchemeShowRoom from '../components/scheme/SchemeShowRoom';
import SafetyDetail from '../components/scheme/SafetyDetail';
import CarDetail from '../components/scheme/CarDetail';
import RoomDetail from "@/components/scheme/RoomDetail";
import WitSite from '../components/apply/WitSite';
import ApplySafety from '../components/apply/ApplySafety';
import ApplyCartoon from '../components/apply/ApplyCartoon';
import ApplyDetail from '../components/apply/ApplyDetail';
import ApplyCarDetail from '../components/apply/ApplyCarDetail';
import Contact from '../components/Contact';
import Empty from "../components/Empty";
import error404 from "../components/error/404";

Vue.use(Router);

const router = new Router({
    routes: [{
            path: '/',
            component: Middle,
        },
        {
            path: '/index/',
            component: Index,
            children: [{
                path: 'empty',
                component: Empty,
                name: 'empty'
            }, {
                path: 'home',
                component: Home,
                meta: {
                    index: '0'
                }
            }, {
                path: 'introduction',
                name: 'introduction',
                component: Introduction,
                meta: {
                    index: '1'
                }
            }, {
                path: 'new',
                component: New
            }, {
                path: 'news-list',
                component: NewsList
            }, {
                path: 'productSite',
                name: 'productSite',
                component: ProductSite,
                meta: {
                    index: '2'
                }
            }, {
                path: 'siteDetail',
                name: 'siteDetail',
                component: SiteDetail,
                meta: {
                    index: '2'
                }
            }, {
                path: 'productSafety',
                name: 'productSafety',
                component: ProductSafety,
                meta: {
                    index: '2'
                }
            }, {
                path: 'productCartoon',
                name: 'productCartoon',
                component: ProductCartoon,
                meta: {
                    index: '2'
                }
            }, {
                path: 'cartoonDetail',
                name: 'cartoonDetail',
                component: CartoonDetail,
                meta: {
                    index: '2'
                }
            }, {
                path: 'safety1',
                component: Safety1,
                meta: {
                    index: '2'
                }
            }, {
                path: 'safety2',
                component: Safety2,
                meta: {
                    index: '2'
                }
            }, {
                path: 'safety3',
                component: Safety3,
                meta: {
                    index: '2'
                }
            }, {
                path: 'safety4',
                component: Safety4,
                meta: {
                    index: '2'
                }
            }, {
                path: 'productSafetyDetail',
                component: ProductSafetyDetail,
                meta: {
                    index: '2'
                }
            }, {
                path: 'live',
                name: 'live',
                component: Live,
                meta: {
                    index: '3'
                }
            }, {
                path: 'liveDetail',
                name: 'liveDetail',
                component: LiveDetail,
                meta: {
                    index: '3'
                }
            }, {
                path: 'site',
                name: 'site',
                component: Site,
                meta: {
                    index: '3'
                }
            }, {
                path: 'schemeSafety',
                name: 'schemeSafety',
                component: SchemeSafety,
                meta: {
                    index: '3'
                }
            }, {
                path: 'schemeCartoon',
                name: 'schemeCartoon',
                component: SchemeCartoon,
                meta: {
                    index: '3'
                }
            }, {
                path: 'schemeSiteDetail',
                name: 'schemeSiteDetail',
                component: SchemeSiteDetail,
                meta: {
                    index: '3'
                }
            }, {
                path: 'schemeShowRoom',
                name: 'schemeShowRoom',
                component: SchemeShowRoom,
                meta: {
                    index: '3'
                }
            }, {
                path: 'safetyDetail',
                name: 'safetyDetail',
                component: SafetyDetail,
                meta: {
                    index: '3'
                }
            }, {
                path: 'carDetail',
                name: 'carDetail',
                component: CarDetail,
                meta: {
                    index: '3'
                }
            }, {
                path: 'roomDetail',
                name: 'roomDetail',
                component: RoomDetail,
                meta: {
                    index: '3'
                }
            }, {
                path: 'witSite',
                name: 'witSite',
                component: WitSite,
                meta: {
                    index: '4'
                }
            }, {
                path: 'applySafety',
                name: 'applySafety',
                component: ApplySafety,
                meta: {
                    index: '4'
                }
            }, {
                path: 'applyCartoon',
                name: 'applyCartoon',
                component: ApplyCartoon,
                meta: {
                    index: '4'
                }
            }, {
                path: 'applyDetail',
                name: 'applyDetail',
                component: ApplyDetail,
                meta: {
                    index: '4'
                }
            }, {
                path: 'applyCarDetail',
                name: 'applyCarDetail',
                component: ApplyCarDetail,
                meta: {
                    index: '4'
                }
            }, {
                path: 'contact',
                name: 'contact',
                component: Contact,
                meta: {
                    index: '5'
                }
            }]
        },
        {
            path: '*',
            component: error404
        }
    ]
});

router.beforeEach((to, from, next) => {
    next();
});


export default router;